import classNames from 'classnames';
import { useField } from 'formik';
import { ReactNode } from 'react';
import { Flex, Heading } from 'yoso';
import { T } from '~/components/I18n';
import { Boost2D } from '~/components/Icon';
import { useFriendsMap } from '~/components/Membership/Membership.hooks';
import { NftContent } from '~/components/Nft/Content/NftContent';
import { formatBoost } from '~/components/Util/number';
import styles from './EvolveSelectedFriendCard.module.scss';

export const titleByOrder: Record<number, ReactNode> = {
  0: <T name="citizen_evolve_unit_button_main" />,
  1: <T name="citizen_evolve_unit_button_material1" />,
  2: <T name="citizen_evolve_unit_button_material2" />,
};

export type EvolveSelectedFriendCard = {
  className?: string;
  active: boolean;
  order: number;
};

export const EvolveSelectedFriendCard = ({
  className,
  active = false,
  order,
}: EvolveSelectedFriendCard) => {
  const { data: friendsMap } = useFriendsMap();
  const [{ value: tokenId }] = useField<string>(`tokenIdList[${order}]`);
  const selectedFriend = friendsMap[tokenId];
  return (
    <div
      className={classNames(styles.root, className, {
        [styles.empty]: !tokenId,
        [styles.active]: active,
      })}>
      <div className={styles.body}>
        <div className={styles.inner}>
          {!!selectedFriend && (
            <NftContent
              originContentsUrl={selectedFriend.originContentsUrl}
              contentsUrl={selectedFriend.contentsUrl}
              contentsType="IMAGE"
              className={styles.cardImage}
            />
          )}
        </div>
      </div>
      <div className={styles.footer}>
        <Heading level={5} className={styles.title}>
          {selectedFriend ? (
            <Flex container alignItems="center" justifyContent="center">
              <Boost2D className={styles.icon} />
              {formatBoost(selectedFriend.meta['Boost'] || 0)}%
            </Flex>
          ) : (
            titleByOrder[order]
          )}
        </Heading>
      </div>
    </div>
  );
};
